import CheckIcon from '@mui/icons-material/Check';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { useRegistry } from '../../store/RegistryStore';
import { statusLabel } from '../../ui/statusTones';

const ROLES = ['REGISTRY_OFFICER', 'APPROVER', 'COMPLIANCE', 'AUDITOR', 'ADMIN'] as const;

const MATRIX: { capability: string; roles: (typeof ROLES)[number][] }[] = [
  {
    capability: 'View register and holders',
    roles: ['REGISTRY_OFFICER', 'APPROVER', 'COMPLIANCE', 'AUDITOR', 'ADMIN'],
  },
  { capability: 'View unmasked TFN (logged)', roles: ['COMPLIANCE', 'ADMIN'] },
  { capability: 'Edit holder details', roles: ['REGISTRY_OFFICER', 'ADMIN'] },
  { capability: 'Draft calls and distributions', roles: ['REGISTRY_OFFICER', 'ADMIN'] },
  { capability: 'Match bank receipts', roles: ['REGISTRY_OFFICER', 'ADMIN'] },
  { capability: 'Approve money and unit movements', roles: ['APPROVER'] },
  { capability: 'Release payments (ABA)', roles: ['APPROVER'] },
  { capability: 'Work KYC/AML cases', roles: ['COMPLIANCE'] },
  { capability: 'Lodge ATO reports', roles: ['COMPLIANCE', 'APPROVER'] },
  { capability: 'Export ledger and audit trail', roles: ['AUDITOR', 'COMPLIANCE', 'ADMIN'] },
  { capability: 'Manage settings and users', roles: ['ADMIN'] },
];

export default function RolesTab() {
  const { state } = useRegistry();
  const users = state.users.filter((user) => user.tenantId === state.currentTenantId);
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Paper variant="outlined">
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Capability</TableCell>
                {ROLES.map((role) => (
                  <TableCell key={role} align="center">
                    {statusLabel(role)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {MATRIX.map((row) => (
                <TableRow key={row.capability}>
                  <TableCell>{row.capability}</TableCell>
                  {ROLES.map((role) => (
                    <TableCell key={role} align="center">
                      {row.roles.includes(role) ? (
                        <CheckIcon fontSize="small" color="success" />
                      ) : (
                        ''
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Paper variant="outlined" sx={{ p: 2.5 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Staff with registry access
        </Typography>
        {users.map((user) => (
          <Typography key={user.id} variant="body2" sx={{ py: 0.5 }}>
            {user.name} — {statusLabel(user.role)}
          </Typography>
        ))}
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 1 }}>
          Registry roles extend the existing admin permissions (src/models/admin/Permission.ts)
          rather than replacing them.
        </Typography>
      </Paper>
    </Box>
  );
}
